import React from 'react';

// react form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import { Button, TextField, Typography } from '@mui/material';
import { ModalBody } from '../../../components/modal/Modal';

import { useAlert } from '../../../hooks/useAlert';

const partiaSchema = yup.object().shape({
  contactPerson: yup.string().required('Povinné'),
  phone: yup.string().required('Povinné'),
  mail: yup.string().email('Zlý format e-mailu').required('Povinné'),
});

const PartieForm = ({ currentPartia, addPartia, editPartia }) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ resolver: yupResolver(partiaSchema) });

  const { success, error: errorAlert, confirm } = useAlert();

  const onSubmit = async (data) => {
    if (!currentPartia) {
      addPartia(data);
    } else {
      editPartia(currentPartia?.id, data);
    }
  };

  return (
    <ModalBody>
      <Typography variant="h6">Nová partia</Typography>
      <TextField
        id="contactPerson"
        label="Kontaktná osoba"
        name="contactPerson"
        variant="outlined"
        defaultValue={currentPartia?.contactPerson}
        error={errors.person}
        helperText={errors.contactPerson?.message}
        {...register('contactPerson')}
      />
      <TextField
        id="phone"
        label="Tel. číslo"
        name="phone"
        variant="outlined"
        defaultValue={currentPartia?.phone}
        error={errors.phone}
        helperText={errors.phone?.message}
        {...register('phone')}
      />
      <TextField
        id="cmail"
        label="E-mail"
        name="mail"
        variant="outlined"
        error={errors.mail}
        defaultValue={currentPartia?.mail}
        helperText={errors.mail?.message}
        {...register('mail')}
      />
      <Button
        variant="outlined"
        onClick={handleSubmit(onSubmit)}
        sx={{
          backgroundColor: '#7fae04',
          color: 'white',
          borderColor: '#7fae04',
          ':hover': {
            backgroundColor: '#7fae04',
            color: 'white',
            opacity: '0.9',
            borderColor: '#7fae04',
          },
        }}
      >
        {currentPartia?.contactPerson ? 'Upraviť' : 'Pridať'}
      </Button>
    </ModalBody>
  );
};

export default PartieForm;
